import React from 'react';

const ErrorLoading: React.FC = () => {
  return (
    <section>
      <div className="mx-auto px-3 py-5 py-lg-5 sec-wrapper">
        <div className="text-center">
          <p className="fs-6 fs-md-5 text-danger">Error loading shop data</p>
        </div>
      </div>
    </section>
  );
};

export default ErrorLoading;
